import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { RESET_CURR_UPLD, RESET_MESSAGES } from "../../base/utils/const";
import { ACCEX } from "../../base/utils/roles";
import { MED_REQ, TOGGLE_ADD_MODAL } from "../../mastertables/utils/const";
import {
  approveDrafts,
  deleteDrafts,
  deleteFiles,
  draftReqImg,
  getUploadsByProfIdAndType,
  updateReqImageAngle,
} from "../actions/managementUploads";
import {
  deleteMedRequest,
  getMedicalRequests,
  saveMedicalRequest,
} from "../actions/studentList";
import { ADD_TO_DEL_MNG_FILES, MED_REC, SET_CUR_REQ } from "../utils/const";
import moment from "moment";
import { sortNames } from "../../sampoorna-siksha/utils/util";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { formItemLayout } from "../../sampoorna-siksha/utils/consts";
import { isValidDoc } from "../../base/utils/utils";
import { MSSSTUD } from "../../base/utils/roles";
import ImageViewer from "../../sampoorna-siksha/components/reviewSteps/ImageViewer";
import { useEffect } from "react";
import {
  APRV,
  DEN,
  MED_EVENT,
  MED_REQ_APPRV,
  PEND,
  TASK_TYPES,
} from "../../common/utils/const";
import TaskComments from "../../common/components/detailTemplates/TaskComments";
import {
  getApprovalLevels,
  getTaskComments,
} from "../../common/actions/TaskActions";
import {
  fetchRequestCategory,
  fetchRequestSubCategory,
} from "../../mastertables/actions/masterTables";
import { canEditRequest, getStatusContent, toCurrency } from "../../common/utils/util";
import { getCurrentUserRole } from "../../service/SessionStorageService";

const dateFormat = "DD/MM/YYYY";
export const EDIT_STUD_MED = "EDIT_STUD_MED";
const STUD_MED_COLS = [
  {
    title: "Date",

    dataIndex: "createdAt",

    key: "createdAt",

    render: (text, record) =>

      record.createdAt ? moment(record.createdAt).format(dateFormat) : "",

    sorter: {

      compare: (a, b) =>

        moment(a.createdAt).unix() - moment(b.createdAt).unix(),
    },
  },
  {
    title: "Type",
    dataIndex: "medicalType",
    key: "medicalType",
    render: (text, record) => record.category.name,
    sorter: {
      compare: (a, b) => sortNames(a.category.name, b.category.name),
    },
  },
  {
    title: "Specialisation",
    dataIndex: "specialization",
    key: "specialization",
    render: (text, record) => record.specialization,
    sorter: {
      compare: (a, b) => sortNames(a.specialization, b.specialization),
    },
  },
  {
    title: "Doctor",
    dataIndex: "doctor",
    key: "doctor",
    render: (text, record) => record.doctor,
    sorter: {
      compare: (a, b) => sortNames(a.doctor, b.doctor),
    },
  },
  {
    title: "Medical Facility",
    dataIndex: "medicalFacility",
    key: "medicalFacility",
    render: (text, record) => record.medicalFacility,
    sorter: {
      compare: (a, b) => sortNames(a.medicalFacility, b.medicalFacility),
    },
  },
  {
    title: "Details",
    dataIndex: "details",
    key: "details",
    render: (text, record) => record.details,
    sorter: {
      compare: (a, b) => sortNames(a.details, b.details),
    },
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text, record) => toCurrency(record.amount),
    sorter: {
      compare: (a, b) => sortNames(a.amount - b.amount),
    },
  },
  {
    title: "Follow up Date",
    dataIndex: "followupDate",
    key: "followupDate",
    render: (text, record) =>
      record.followupDate ? moment(record.followupDate).format(dateFormat) : "",
    sorter: {
      compare: (a, b) =>
        moment(a.followupDate).unix() - moment(b.followupDate).unix(),
    },
  },
  {
    title: "Follow up Details",
    dataIndex: "followupDetails",
    key: "followupDetails",
    render: (text, record) => record.followupDetails,
    sorter: {
      compare: (a, b) => sortNames(a.followupDetails, b.followupDetails),
    },
  },
];

export const MedicalRequesForm = (props) => {
  const [formUpdated, setFormUpdated] = useState(false);
  const [form] = Form.useForm();
  const [uploadedFiles, setUploadedFiles] = useState([]);

  // useEffect(() => {
  //   props.resetUploads();
  // }, []);

  useEffect(() => {
    const uploadedFiles = [];
    for (const up of props.mgUploads.newAttach) {
      if (
        up.type === MED_REC &&
        ((up.status === "P" && !up.entityId) ||
          up.entityId === props.manage.currentRequest.medicalRequestID)
      ) {
        uploadedFiles.push(up);
      }
    }
    const uniqueUploads = Array.from(
      new Set(uploadedFiles.map((a) => a.managementUploadId))
    ).map((id) => {
      return uploadedFiles.find((a) => a.managementUploadId === id);
    });
    setUploadedFiles(uniqueUploads);
  }, [props.mgUploads.newAttach]);

  const onFinish = (form) => {
    console.log("-------", form);
    const studentProfileId = props.manage.currentProfile.studentProfileId;
    form.studentProfileId = studentProfileId;

    if (props.role === MSSSTUD && uploadedFiles.length === 0) {
        message.error("Please upload valid file less than 500 KB.");
        return;
    } 
    const newFiles = uploadedFiles.find(up => up.status === "P" && !up.entityId);
    props.saveMedicalRequest({
      request: form,
      studentProfileId: studentProfileId,
      uploadId: newFiles?.managementUploadId,
      comment: form.comment,
    });
  };

  const onCancel = () => {
    form.resetFields();
    props.toogleAddModal("");
  };

  const onValueChange = () => {
    setFormUpdated(true);
  };

  const setFiles = (e) => {
    const file = document.getElementById("medReqFileUpload").files[0];
    if (!file) {
      return;
    }

    if (!isValidDoc(file)) {
      message.error("Please upload valid file less than 500 KB.");
      document.getElementById("medReqFileUpload").value = "";
      return;
    }

    const currentProfile = props.manage.currentProfile;

    // Save the new image uploaded as a draft.
    props.draftReqImg(
      currentProfile.studentProfileId,
      file,
      MED_REC,
      currentProfile.batch
    );
    document.getElementById("medReqFileUpload").value = "";
  };

  const handleUpload = () => {
    document.getElementById("medReqFileUpload").click();
  };

  return (
    <>
      <Modal
        visible={props.manage.showModal === EDIT_STUD_MED}
        footer={null}
        onCancel={() => onCancel()}
        width="80%"
      >
        <div>
          <Spin tip="Loading..." spinning={props.masterTable.loading}>
            <Card
              title={
                props.manage.currentRequest.medicalRequestID
                  ? "Edit Medical Request"
                  : "Add Medical Request"
              }
            >
              <div>
                <Form
                  initialValues={props.manage.currentRequest}
                  onFinish={onFinish}
                  form={form}
                  onValuesChange={(e) => onValueChange(e)}
                >
                  <Form.Item
                    {...formItemLayout}
                    name="medicalRequestID"
                    hidden={true}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    {...formItemLayout}
                    name="studentProfileId"
                    hidden={true}
                  >
                    <Input />
                  </Form.Item>
                  <Row gutter={[16, 8]}>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="medicalType"
                        label="Medical Type"
                        rules={[
                          {
                            required: true,
                            message: "Please select Medical Type",
                          },
                        ]}
                      >
                        <Select className="full-width">
                          {props.masterTable.reqCat.map((typ) => (
                            <Select.Option
                              key={typ.requestCategoryId}
                              value={typ.requestCategoryId}
                            >
                              {typ.name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="specialization"
                        label="Specialisation"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Doctor Specialisation",
                          },
                        ]}
                      >
                        <Input maxLength="250"/>
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="doctor"
                        label="Doctor Name"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Doctor Name",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="medicalFacility"
                        label="Medical Facility"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Medical Facility name",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="requestDate"
                        label="Date"
                        rules={[
                          {
                            required: true,
                            message: "Please select Join Date",
                          },
                        ]}
                      >
                        <DatePicker
                          format={dateFormat}
                          className="full-width"
                          showToday={false}
                        />
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="details"
                        label="Details"
                        rules={[
                          {
                            required: true,
                            message: "Please enter Details",
                          },
                        ]}
                      >
                        <Input.TextArea />
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="amount"
                        label="Amount"
                        rules={[
                          {
                            pattern: /^[1-9][0-9]*$/,
                            message: "Please enter a valid Amount",
                          },
                        ]}
                      >
                        <Input maxLength="10"/>
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="followupDate"
                        label="Follow up Date"
                      >
                        <DatePicker
                          format={dateFormat}
                          className="full-width"
                          showToday={false}
                        />
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      <Form.Item
                        {...formItemLayout}
                        name="followupDetails"
                        label="Follow up Details"
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(rule, value) {
                              if (
                                formUpdated &&
                                !value &&
                                getFieldValue("followupDate")
                              ) {
                                return Promise.reject(
                                  "Please enter details of follow up."
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input.TextArea />
                      </Form.Item>
                    </Col>
                    <Col sm={12} xs={24}>
                      {props.manage.currentRequest.medicalRequestID && (
                        <Form.Item
                          {...formItemLayout}
                          name="comment"
                          label="Comments"
                          rules={[
                            {
                              required: true,
                              message:
                                "Please add comments related to request update.",
                            },
                          ]}
                        >
                          <Input.TextArea maxLength="1000" />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>

                      <Form.Item
                        name="upload"
                        label="Upload file"
                        {...formItemLayout}
                      >
                        <Button
                          icon={<UploadOutlined />}
                          onClick={(e) => handleUpload(e)}
                        >
                          Click to Upload file
                        </Button>
                      </Form.Item>

                      <input
                        type="file"
                        id="medReqFileUpload"
                        style={{ display: "none" }}
                        onChange={setFiles}
                      ></input>
                      <ImageViewer
                        imageList={uploadedFiles}
                        showActions={false}
                        loading={props.manage.loading}
                        year={props.manage.currentProfile?.batch}
                        {...props}
                      />

                  <div style={{ textAlign: "center" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button mg-l"
                      disabled={props.manage.loading}
                    >
                      Submit
                    </Button>
                    <Button
                      className="login-form-button mg-l"
                      onClick={() => onCancel()}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </div>
            </Card>
          </Spin>
        </div>
      </Modal>
    </>
  );
};

const MedicalRequestComments = (props) => {
  return (
    <div>
      <Spin spinning={props.commentsLoading}>
        <TaskComments comments={props.comments} />
      </Spin>
    </div>
  );
};

const MedicalRequests = (props) => {
  // const [currentRecord, setCurrentRecord] = useState({});
  const [approvalLevels, setApprovalLevels] = useState(
    props.tasks.approvalLevels
  );
  const [requests, setRequests] = useState([]);
  const [profileId, setProfileId] = useState(0);

  useEffect(() => {
    if (props.tasks.approvalLevels.length === 0) {
      props.getApprovalLevels();
    }
    props.getReqCats(MED_REQ);
    return () => {
      props.setCurrentRequest({});
    };
  }, []);

  useEffect(() => {
    if (props.manage.currentProfile.studentProfileId) {
      const pId = props.manage.currentProfile.studentProfileId;
      props.getMedicalRequests(pId);
      setProfileId(pId);
    }
  }, [props.manage.currentProfile.studentProfileId]);

  useEffect(() => {
    if (props.tasks.approvalLevels.length > 0) {
      setApprovalLevels(props.tasks.approvalLevels);
    }
  }, [props.tasks.approvalLevels]);

  useEffect(() => {
    if (props.manage.currentProfile.medicalRequests?.length > 0) {
      const req = props.manage.currentProfile.medicalRequests;
      for (const r of req) {
        if (
          props.mgUploads.attachments &&
          props.mgUploads.attachments.length > 0
        ) {
          r.attach = props.mgUploads.attachments.filter(
            (at) => at.entityId === r.medicalRequestID && at.type === MED_REC
          );
        } else {
          r.attach = [];
        }
        r.batch = props.manage.currentProfile.batch;
      }
      setRequests(req);
    }
  }, [
    props.manage.currentProfile.medicalRequests,
    props.mgUploads.attachments,
    props.manage.currentProfile.batch,
  ]);

  const hasAccess = (currentLevel) => {
    if(!currentLevel) {
      if(props.role === MSSSTUD) {
        return true;
      }
      if (props.role && props.role !== ACCEX) {
        const taskTypes = TASK_TYPES[props.role];
        if (taskTypes) {
          return taskTypes.indexOf(MED_REQ_APPRV) > -1;
        }
      }
      return false;
    }
    if(props.role === MSSSTUD) {
      return canEditRequest(currentLevel - 1, props.role, MED_REQ_APPRV.value);
    }
    return canEditRequest(currentLevel, props.role, MED_REQ_APPRV.value);
  };

  const addRecord = () => {
    props.setCurrentRequest({});
    props.toogleAddModal(EDIT_STUD_MED);
  };

  const editRecord = (record, e) => {
    e.preventDefault();
    record.requestDate = moment(record.requestDate);
    if (record.followupDate) {
      record.followupDate = moment(record.followupDate);
    }
    props.setCurrentRequest(record);
    props.toogleAddModal(EDIT_STUD_MED);
  };

  const deleteRecord = (record, e) => {
    e.preventDefault();
    Modal.confirm({
      title: "Do you want to delete this request?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        props.deleteMedRequest(record.medicalRequestID, profileId);
      },
      onCancel() {},
      okText: "Yes",
      cancelText: "No",
    });
  };

  if (STUD_MED_COLS.length < 11 && approvalLevels.length > 0) {
    STUD_MED_COLS.push({
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) =>
        getStatusContent(
          approvalLevels,
          record.assignedLevel,
          record.status,
          MED_REQ_APPRV.value
        ),
      sorter: {
        compare: (a, b) => {
          if (a.assignedLevel !== b.assignedLevel) {
            return a.assignedLevel - b.assignedLevel;
          } else if (
            a.assignedLevel === b.assignedLevel &&
            a.status !== b.status
          ) {
            if (a.status === APRV || a.status === DEN) {
              return 1;
            } else if (b.status === APRV || b.status === DEN) {
              return -1;
            }
          } else if (
            a.assignedLevel === b.assignedLevel &&
            a.status === b.status
          ) {
            return 0;
          } else {
            return 0;
          }
        },
      },
    });
    STUD_MED_COLS.push({
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Space size="middle">
            {record.attach && (
              <ImageViewer
                imageList={record.attach}
                showActions={false}
                showPin={true}
                year={record.batch}
                {...props}
              />
            )}
            {(hasAccess(record.assignedLevel)) && (
              <a href="/" onClick={(e) => editRecord(record, e)}>
                <EditOutlined />
              </a>
            )}
            {(hasAccess(record.assignedLevel)) && (
              <a href="/" onClick={(e) => deleteRecord(record, e)}>
                <DeleteOutlined />
              </a>
            )}
          </Space>
        </>
      ),
    });
  }

  return (
    <React.Fragment>
      <Card>
        <h2>
          Medical Requests
          <Button
            onClick={addRecord}
            type="primary"
            style={{ float: "right" }}
            disabled={!hasAccess()}
          >
            Add
          </Button>
        </h2>
        <Spin spinning={props.manage.loading} delay={500}>
          <div className="overflow-table">
            {approvalLevels.length > 0 && (
              <Table
                columns={STUD_MED_COLS}
                dataSource={requests}
                rowKey={(record) => record.medicalRequestID}
                pagination={{ showSizeChanger: true }}
                expandable={{
                  expandedRowRender: (record) => (
                    <MedicalRequestComments
                      request={record}
                      comments={record.comments}
                      commentsLoading={props.tasks.loading}
                    />
                  ),
                  // rowExpandable: record => true,
                  onExpand: (expanded, record) => {
                    if (expanded) {
                      props.getTaskComments(record.medicalRequestID, MED_EVENT);
                    }
                  },
                }}
              />
            )}
          </div>
        </Spin>
      </Card>
      {props.manage.showModal === EDIT_STUD_MED && (
        <MedicalRequesForm {...props} />
      )}
      {props.onClose !== undefined && (
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <Button onClick={(e) => props.onClose(e)} style={{ marginRight: 8 }}>
            Close
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    // offlineSearch(searchText, profiles) {
    //   if (searchText && searchText.length > 1) {
    //     const result = profiles.filter((profile) => {
    //       return studProfPredicate(profile, searchText);
    //     });
    //     dispatch({
    //       type: SET_FILTERED_PROFILES,
    //       payload: result,
    //     });
    //   } else if (!searchText) {
    //     dispatch({
    //       type: SET_FILTERED_PROFILES,
    //       payload: profiles,
    //     });
    //   }
    // },

    getApprovalLevels() {
      dispatch(getApprovalLevels());
    },

    getMedicalRequests(id) {
      dispatch(getUploadsByProfIdAndType(id, MED_REC)).then((res) => {
        dispatch(getMedicalRequests(id));
      });
    },

    getTaskComments(entityId, entityType) {
      dispatch(getTaskComments(entityId, entityType));
    },

    getReqCats(id) {
      dispatch(fetchRequestCategory(id));
    },

    getReqSubCats(id) {
      dispatch(fetchRequestSubCategory(id));
    },

    saveMedicalRequest(form) {
      dispatch(saveMedicalRequest(form)).then((res) => {
        this.getMedicalRequests(form.studentProfileId);
      });
    },

    deleteMedRequest(id, profileId) {
      dispatch(deleteMedRequest(id)).then((res) => {
        this.getMedicalRequests(profileId);
      });
    },

    updateImageAngle(angle, uploadId) {
      dispatch(updateReqImageAngle(uploadId, angle));
    },

    draftReqImg(studentProfileId, file, type, batch) {
      dispatch(draftReqImg(studentProfileId, file, type, batch));
    },

    deleteDraft(studentProfileId) {
      dispatch(deleteDrafts(studentProfileId));
    },

    deleteFiles(filesList) {
      dispatch(deleteFiles(filesList));
    },

    addToDeleteFiles(filesList) {
      dispatch({
        type: ADD_TO_DEL_MNG_FILES,
        payload: filesList,
      });
    },

    approveDrafts(studentProfileId, filesList) {
      dispatch(approveDrafts(studentProfileId, filesList));
    },

    toogleAddModal(modal) {
      dispatch({
        type: TOGGLE_ADD_MODAL,
        payload: modal,
      });
    },

    resetUploads() {
      dispatch({
        type: RESET_CURR_UPLD,
      });
    },

    getUploadsByProfIdAndType(profId, type) {
      dispatch(getUploadsByProfIdAndType(profId, type));
    },

    setCurrentRequest(data) {
      dispatch({
        type: SET_CUR_REQ,
        payload: data,
      });
    },

    resetMessage() {
      dispatch({
        type: RESET_MESSAGES,
      });
    },
  };
};

const mapStateToProps = (state) => {
  const {
    AuthReducer,
    AdminReducer,
    ManagementReducer,
    MasterTablesReducer,
    AppConfigReducer,
    ManagementUploadReducer,
    TaskReducer,
  } = state;
  return {
    profile: AuthReducer.profile,
    lang: AuthReducer.lang,
    role: AuthReducer.role,
    admin: AdminReducer,
    manage: ManagementReducer,
    masterTable: MasterTablesReducer,
    appConfig: AppConfigReducer,
    mgUploads: ManagementUploadReducer,
    comments: TaskReducer.taskComments,
    tasks: TaskReducer,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MedicalRequests)
);
